import "./Footer.scss";
import logo from "../../assets/logo.svg";
import location from "../../assets/hero/location.svg";
import mail from "../../assets/hero/mail.svg";
import insta from "../../assets/hero/instagram.svg";
import linkedin from "../../assets/hero/linkedin.svg";
import twitter from "../../assets/hero/twitter.svg";

function Footer() {
  return (
    <div className="footer">
      <div className="upper">
        <div className="about_gdsc">
          <div className="logo">
            <img src={logo} alt="logo" />
          </div>
          <div className="about_gdsc__name">
            <p className="about_gdsc__name__p1">Google Developer Student Clubs</p>
            <p>RCOEM</p>
          </div>
        </div>

        <div className="info">
          <div className="locationInfo">
            <img id="loc" src={location} alt="Location logo" />
            <p>
              Shri Ramdeobaba College of Engineering and Management, Ramdeo Tekdi, Gittikhadan,
              Katol Road, Nagpur- 440013
            </p>
          </div>

          <div className="mailInfo">
            <img id="mail" src={mail} alt="Mail logo" />
            <a href="mailto:dsc.rknec@gmail.com?">dsc.rknec@gmail.com</a>
          </div>
        </div>

        <div className="social">
          Follow us:
          <div className="links">
            <a
              href="https://instagram.com/gdsc_rcoem?igshid=YmMyMTA2M2Y="
              target="_blank"
              rel="noreferrer"
            >
              <img src={insta} alt="Instagram logo" />
            </a>
            <a href="https://www.linkedin.com/company/gdsc-rcoem/" target="_blank" rel="noreferrer">
              <img src={linkedin} alt="Linkedin logo" />
            </a>
            <a href="https://twitter.com/gdsc_rcoem" target="_blank" rel="noreferrer">
              <img src={twitter} alt="Twitter logo" />
            </a>
          </div>
        </div>
      </div>
      <div className="endLine">
        Made with <span>♥</span> by GDSC RCOEM
      </div>
    </div>
  );
}
export default Footer;
